//baseline
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/do';

//entry point
import { AppComponent } from './app.component';
import { routing } from './app.routing'

//eia services
import { ApiService } from './services/api.service';
import { ErrorInterceptor } from './services/error.interceptor';
import { EiaChartsService } from '../app/share-modules/eia-charts/eia-charts.service';
//eia custom modules
import { DashboardModule } from './dashboard/dashboard.module';
import { CommentaryModule } from './commentary/commentary.module';
import { RelatedLinksModule } from './related-links/related-links.module';
import {CommentaryService} from "./commentary/services/commentary.service";
import { DatePipe } from '@angular/common'
import { MyDateRangePickerModule } from 'mydaterangepicker';
import {PdfSelectorComponent} from "./pdf-selector/pdf-selector.component";



@NgModule({
  declarations: [
    AppComponent,
      PdfSelectorComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    HttpClientModule,
    routing,
    DashboardModule,
    CommentaryModule,
    RelatedLinksModule,
    MyDateRangePickerModule,
  ],
  providers: [
    ApiService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
      EiaChartsService,
      CommentaryService,
      DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts